import { RightOutlined } from '@ant-design/icons';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { Collapse } from 'antd';
import clx from 'classnames';
import type * as React from 'react';
import { useMemo } from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled from 'styled-components';
import { CommunicationMessage } from './CommunicationMessage.tsx';
import { CommunicationSubject } from './CommunicationSubject.tsx';

const CommunicationCollapse = styled(Collapse)`
  &.is-draft {
    background-color: #f6ffed;
    border-color: ${props => props.theme.colorSuccess};
    border-width: 2px;
    > .ant-collapse-item {
      border-color: ${props => props.theme.colorSuccess};
      border-width: 2px;
    }
  }
  & > .ant-collapse-item {
    > .ant-collapse-header {
      align-items: center;
    }
  }
`;

export interface CommunicationContainerProps {
  isCurrentUser?: boolean;
  avatar?: React.ReactNode;
  header?: React.ReactNode;
  actors?: React.ReactNode;
  subject?: string | null;
  message?: string | null;
  attachments?: React.ReactNode;
  forward?: React.ReactNode;
  isDraft?: boolean;
  headerExtra?: React.ReactNode;
  isPreview?: boolean;
}

/**
 * Conteiner grafico di una comunicazione
 */
export function CommunicationContainer(props: CommunicationContainerProps) {
  const {
    avatar,
    isCurrentUser,
    header,
    subject,
    message,
    attachments,
    actors,
    isDraft,
    headerExtra,
    isPreview,
    forward,
  } = props;
  const isMobile = useBreakpoint(down('sm'));

  const content = useMemo(() => {
    return (
      <div>
        <div>{actors}</div>
        <CommunicationSubject subject={subject} />
        <CommunicationMessage message={message} />
        <div>{attachments}</div>
        <div>{forward}</div>
      </div>
    );
  }, [actors, attachments, forward, message, subject]);

  const avatarToShow = !isMobile ? avatar : undefined;

  return (
    <div>
      <FlexRow
        gutter={12}
        align="flex-start"
        left={isCurrentUser ? undefined : avatarToShow}
        right={isCurrentUser ? avatarToShow : undefined}
      >
        {isPreview ? (
          content
        ) : (
          <CommunicationCollapse
            className={clx({ 'is-draft': isDraft })}
            expandIcon={panel => (
              <RightOutlined
                rotate={panel.isActive ? 90 : 0}
                aria-hidden="true"
              />
            )}
            size="small"
            items={[
              {
                key: 'item',
                label: header,
                extra: headerExtra,
                children: content,
              },
            ]}
          />
        )}
        {/* <Card size="small" title={header}>
          <SubjectTitle level={5}>{subject}</SubjectTitle>
          <div>{message}</div>
          {attachments}
        </Card> */}
      </FlexRow>
    </div>
  );
}
